/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.WalkinManager.AddToWaitlist {

    import Client = Meevo.Model.Client;

    export interface IClientList {
        clients: Array<Client>,
        currentClient: Client,
        newClientTemplate: Client,
        fetchClients: Function,
        fetchClientTemplate: Function,
        getClientById: Function,
        createClient: Function,
        updateClient: Function
    }

    export class ClientList implements IClientList {
        _currentClient: Client;
        _newClientTemplate: Client;
        _clientList: Array<Client>;

        constructor (
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected $q: ng.IQService,
            currentClient?: Client,
            clientList?: Array<Client>
        ) {
            this.currentClient = currentClient || null;
            this.clients = clientList || [];
        }

        fetchClients () {
            this.busyService.start();
            this.dataService.getListPaged('client', {
                criteria: {
                    'eligibleForWalkinManager': true
                }
            })
                .then((result: Array<Client>|any) => {
                    this.clients = result;
                })
                .finally(() => {
                    this.busyService.stop();
                });
        }

        fetchClientTemplate (): ng.IPromise<any> {
            let deferred = this.$q.defer();

            this.busyService.start();
            this.dataService.getTemplate('client')
                .then((client: Client) => {
                    this.newClientTemplate = client;
                    deferred.resolve(client);
                })
                .finally(() => {
                    this.busyService.stop();
                });

            return deferred.promise;
        }

        getClientById (id: Guid): ng.IPromise<any> {
            let deferred = this.$q.defer();

            this.dataService.getItem('client', id)
                .then((client: Client|any) => {
                    client['displayName'] = `${client['lastName']}, ${client['firstName']} ${client['middleName'] || ''}`;
                    client['countryCode'] = client['phoneNumbers'].length ? client['phoneNumbers'][0]['countryCode'] : '';
                    client['primaryPhoneNumber'] = client['phoneNumbers'].length ? client['phoneNumbers'][0]['number'] : '';
                    this.currentClient = client;
                    deferred.resolve(client);
                })
                .catch(() => {
                    deferred.reject();
                });

            return deferred.promise;
        }

        updateClient (editData: Client): ng.IPromise<any> {
            let deferred = this.$q.defer();

            this.dataService.update('client', editData)
                .then(() => {
                    editData['displayName'] = `${editData['lastName']}, ${editData['firstName']} ${editData['middleName'] || ''}`;
                    editData['countryCode'] = editData['phoneNumbers'].length ? editData['phoneNumbers'][0]['countryCode'] : '';
                    editData['primaryPhoneNumber'] = editData['phoneNumbers'].length ? editData['phoneNumbers'][0]['number'] : '';
                    this.currentClient = editData;
                    deferred.resolve()
                })
                .catch(() => {
                    deferred.reject();
                });

            return deferred.promise;
        }

        createClient(data: Client): ng.IPromise<any> {
            let deferred = this.$q.defer();

            this.dataService.add('client', {
                ...data,
                isWalkin: true,
            }).then((clientData) => {
                    clientData['displayName'] = `${clientData.lastName}, ${clientData.firstName} ${clientData.middleName || ''}`;
                    clientData['countryCode'] = clientData['phoneNumbers'][0]['countryCode'];
                    clientData['primaryPhoneNumber'] = clientData['phoneNumbers'][0]['number'];

                    this.currentClient = clientData;
                    deferred.resolve(clientData);
                })
                .catch(() => {
                    deferred.reject();
                });

            return deferred.promise;
        }

        get clients(): Array<Client> {
            return this._clientList;
        }

        set clients(data: Array<Client>) {
            this._clientList = data;
        }

        get currentClient(): Client {
            return this._currentClient;
        }

        set currentClient(client: Client) {
            this._currentClient = client;
        }

        get newClientTemplate(): Client {
            return this._newClientTemplate;
        }

        set newClientTemplate(client: Client) {
            this._newClientTemplate = client;
        }
    }

}